let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("9uVpc")).then(() => parcelRequire('8CvsG'));